<div id="divForm">
    <div id="separador" style="height:20px; background:white;">
        <label class="labelTyping" [hidden]="!agentTyping">Asesor escribiendo</label>
    </div>
    <div class="input-bar">
        <div class="input-bar-inner">
            <div class="input-bar-text-area">

                <textarea id="input-text" maxlength="300" rows="2"
                    [placeholder]="getPlaceholder()"
                    [disabled]="(!agentesDisponibles) || cambioDeServicio || fueraHorario || !habilitado"
                    (keyup.enter)="sendMessage()" (focusout)="escribiendo(false)" (keydown)="escribiendo(true)"
                    [(ngModel)]="message.content"></textarea>

                <button
                    [disabled]="!(message.content.length > 0) || (!agentesDisponibles) || cambioDeServicio || fueraHorario || !habilitado"
                    (click)="sendMessage()" class="enviar">
                    <img src="assets/images/iconoAvion.PNG">
                </button>

            </div>
            <div style="background:white;"></div>
        </div>
    </div>
    <div class="spinner-center" style="padding-bottom: 5px; padding-top: 5px" *ngIf="ctx.hideAllButtonsForm">
        <app-boton-secundario-consulta boton_texto="Volver al inicio"
            (boton_funcion)="switchAssistantHandler()"></app-boton-secundario-consulta>
    </div>

</div>